console.log(`*** version: 22-1 ***`);

$('.invite-landing-main-slide').slick({
  infinite: true,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  draggable: false,
  variableWidth: true,
  pauseOnFocus: false,
  pauseOnHover: false,
  centerMode: true,
});

$('.invite-landing-freeitem-slot').slick({
  rows: 1,
  dots: true,
  infinite: true,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 1000,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  draggable: true,
  pauseOnFocus: true,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1340,
      settings: {
        arrows: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        // centerMode: true,
        variableWidth: true,
      },
    },
  ],
});

const FAB365_LIVE_LANDING = 'https://ad.fab365.net/';
const FAB365_LIVE_URL = 'https://fab365.net/';

const FAB365_DEV_LANDING = 'https://dev-ad.fab365.net/';
const FAB365_DEV_URL = 'https://dev2.fab365.net/';

const FAB365_LIVE_DEV_LANDING = 'https://ad2.fab365.net/live1';
const FAB365_LIVE_DEV_URL = 'https://live.fab365.net/';
const LOCAL_URL = `http://127.0.0.1:${window.location.port}/index.html`;
const GOTO_FAB365_DEV_URL = `https://dev2.fab365.net/`;

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag('js', new Date());
gtag('config', 'G-0Z2E6KLFJG');

// 소셜 공유 함수
document.addEventListener('DOMContentLoaded', function () {
  // 소셜미디어 공유
  const link = window.location.href;

  // Facebook 공유
  const shareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${link}`);
  };

  const facebookElements = document.getElementsByClassName('invite-landing-social-facebook');

  for (let i = 0; i < facebookElements.length; i++) {
    facebookElements[i].addEventListener('click', shareFacebook);
  }

  // Twitter 공유
  const shareTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?url=${link}`);
  };

  const twitterElements = document.getElementsByClassName('invite-landing-social-x');

  for (let i = 0; i < twitterElements.length; i++) {
    twitterElements[i].addEventListener('click', shareTwitter);
  }

  //  링크 복사
  const shareUrl = () => {
    let textarea = document.createElement('textarea');
    document.body.appendChild(textarea);
    textarea.value = link;
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    alert('The invitation link has been copied. ');
  };

  const linkElements = document.getElementsByClassName('invite-landing-social-link');

  for (let i = 0; i < linkElements.length; i++) {
    linkElements[i].addEventListener('click', shareUrl);
  }

  const urlParams = new URLSearchParams(location.search);
  let inviteToken = urlParams.get('t');
  if (!inviteToken) inviteToken = 'google';

  const onClickSignUp = () => {
    // TODO: 개발 Url 변경
    if (link.includes('dev-ad')) {
      // gtag - signup 버튼 클릭 이벤트 전송
      gtag('event', 'ad.landing_signup_click', {
        event_category: 'User Interaction',
        event_label: 'Signup Button Clicked',
      });
      // window.open(`http://localhost:3000?t=${inviteToken}`);
      window.open(`https://dev2.fab365.net?t=${inviteToken}`);
    } else {
      // gtag - signup 버튼 클릭 이벤트 전송
      gtag('event', 'ad.landing_signup_click', {
        event_category: 'User Interaction',
        event_label: 'Signup Button Clicked',
      });
      window.open(`https://fab365.net?t=${inviteToken}`);
      // window.open(`http://localhost:3003?t=${inviteToken}`);
    }
  };
  document
    .querySelectorAll('#SIGNUP_BTN')
    .forEach(el => el.addEventListener('click', onClickSignUp));

  const onDownloadItem = e => {
    // TODO: 개발 Url 변경
    if (link.includes('dev-ad')) {
      // gtag - download 버튼 클릭 이벤트 전송
      gtag('event', 'ad.landing_download_click', {
        event_category: 'User Interaction',
        // event_label: `${e.target.value} - Download Button Clicked`,
        event_label: `Download Button Clicked`,
      });
      // window.open(`http://localhost:3000?t=${inviteToken}&item=${e.target.value}`);
      window.open(`https://dev2.fab365.net?t=${inviteToken}`);
    } else {
      // gtag - download 버튼 클릭 이벤트 전송
      gtag('event', 'ad.landing_download_click', {
        event_category: 'User Interaction',
        event_label: `${e.target.value} - Download Button Clicked`,
      });
      window.open(`https://fab365.net?t=${inviteToken}`);
      // window.open(`http://localhost:3003?t=${inviteToken}`);
    }
  };
  document
    .querySelectorAll('#DOWNLOAD_BTN')
    .forEach(el => el.addEventListener('click', onDownloadItem));
});
